import { render, staticRenderFns } from "./ArchivesReportages.vue?vue&type=template&id=73d2be83&scoped=true"
import script from "./ArchivesReportages.vue?vue&type=script&lang=js"
export * from "./ArchivesReportages.vue?vue&type=script&lang=js"
import style0 from "./ArchivesReportages.vue?vue&type=style&index=0&id=73d2be83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d2be83",
  null
  
)

export default component.exports